import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { currentUser } = useAuth();

    console.log('ProtectedRoute Check:', {
        path: window.location.pathname,
        currentUser,
        role: currentUser?.role,
        adminOnly
    });

    if (!currentUser) {
        console.log('Redirecting to /login (No User)');
        if (adminOnly) {
            return <Navigate to="/admin-login" replace />;
        }
        return <Navigate to="/home" replace />;
    }

    if (adminOnly) {
        const hasAdminAccess = ['admin', 'staff'].includes((currentUser.role || '').toLowerCase());
        if (!hasAdminAccess) {
            console.log(`Redirecting to /home (Role '${currentUser.role}' does not have web dashboard access)`);
            // Redirect to home if admin platform privileges are required but not present
            return <Navigate to="/home" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
